import React from 'react';
import { translate } from 'translations/translator';
import closeImagePath from 'assets/photo/worksheet-maker/header/close-button.png';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
const t = key => translate('worksheet', key);

const TeachingTipsModal = ({ teachingTipsModalVisible, onCloseModal }) => {
  const handleEscPress = event => {
    if (['Escape', 'Enter', ' '].includes(event.key)) {
      onCloseModal();
    }
  };

  return (
    <TrapFocus
      open={teachingTipsModalVisible}
      isEnabled={() => teachingTipsModalVisible}
      getDoc={() => document}
    >
      <div
        role="dialog"
        aria-labelledby="modal-title"
        aria-describedby="modal-subtitle"
        aria-modal="true"
        className={`teaching-tips-modal ${teachingTipsModalVisible ? 'visible' : ''}`}
        tabIndex={-1}
        onKeyDown={handleEscPress}
        style={{ zIndex: 9999 }}
      >
        <div className="modal-window">
          <div className="modal-header">
            <h1 className="title" id="modal-title">
              {t('teachingTipsModalTitle')}
            </h1>
            <p
              className="subtitle"
              id="modal-subtitle"
              dangerouslySetInnerHTML={{ __html: t('teachingTipsSubTitle') }}
            />
          </div>
          <button type="button" className="close-section" onClick={onCloseModal}>
            <span className="close-text">{t('CLOSE')}</span>
            <img className="close-image" src={closeImagePath} alt="" aria-hidden="true" />
          </button>
          <div className="modal-content">
            <div className="column-1">
              <p dangerouslySetInnerHTML={{ __html: t('teachingTipsCol1P1') }} />
              <p dangerouslySetInnerHTML={{ __html: t('teachingTipsCol1P2') }} />
              <p dangerouslySetInnerHTML={{ __html: t('teachingTipsCol1P3') }} />
              <p>{t('teachingTipsCol1P4')}</p>
              <p>{t('teachingTipsCol1P5')}</p>
            </div>
            <div className="column-2">
              <p dangerouslySetInnerHTML={{ __html: t('teachingTipsCol2P1') }} />
              <p>{t('teachingTipsCol2P2')}</p>
              <p dangerouslySetInnerHTML={{ __html: t('teachingTipsCol2P3') }} />
            </div>
          </div>
        </div>
      </div>
    </TrapFocus>
  );
};

export default TeachingTipsModal;
